import * as React from "react";
import {FC} from "react";
import Page from "../../layout/Page";
import PageHeader from "../../layout/PageHeader";
import PageContent from "../../layout/PageContent";
import {ItemIssuesList} from "../brand/brandItem/issues/ItemIssuesList";

export const LogisticsItemIssuesPath = () => {
   return "/logistics/itemissues"
}

export const LogisticsItemIssuesPage: FC<any> = () => {
   return <Page>
      <PageHeader title={"Item Issues"}/>
      <PageContent fullHeight>
         <ItemIssuesList/>
      </PageContent>
   </Page>
}